if (!customElements.get('ck-recliner-selection')) {
  customElements.define('ck-recliner-selection', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('[data-recliner-variants]').textContent);
      this.scope = this.closest('.shopify-section');
      this.invalidIds = new Set(this.variants.filter(v => v.options.includes('Default Title')).map(v => String(v.id)));
      const signal = this.controller.signal;
      const validSelection = () => {
        const id = this.scope.querySelector('product-form-component input[name="id"]')?.value;
        return !this.invalidIds.has(String(id));
      };
      const sync = () => {
        const valid = validSelection();
        this.querySelector('[data-recliner-invalid]').hidden = valid;
        this.querySelector('[data-recliner-selection]').hidden = !valid;
        if (!valid) this.scope.querySelectorAll('button.add-to-cart-button').forEach(button => { button.disabled = true; });
      };
      this.scope.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const variant = event.detail?.resource;
        if (variant) this.querySelector('[data-recliner-selection]').textContent = this.dataset.selectionLabel + ': ' + variant.title;
        queueMicrotask(sync);
      }, {signal});
      const guard = event => {
        const button = event.target.closest?.('button.add-to-cart-button');
        if (!validSelection() && (event.type === 'submit' || button)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.scope.querySelector('variant-picker input:not([disabled])')?.focus();
        }
      };
      this.scope.addEventListener('submit', guard, {capture:true, signal});
      this.scope.addEventListener('click', guard, {capture:true, signal});
      queueMicrotask(sync);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
